import { styled } from "@mui/material/styles";
import { Box, Typography, TextField, Chip } from "@mui/material";
import { colors } from "../../../theme/theme";

export const StyledWrapper = styled(Box)({});

export const StyledLabelBox = styled(Box)({
  marginBottom: 8,
});

export const StyledLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color, theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "1rem",
  color: color || colors.primary,
  fontWeight: "600",
  textAlign: "left",
  height: 24,
  whiteSpace: "nowrap",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

export const RequiredMark = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: theme.spacing(2),
  color: "red",
}));

export const StyledInputContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  fontWeight: "400",
  color: color || colors.primary,
  borderRadius: "14px",
  border: "1px solid #fff",
}));

export const StyledTagInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ theme, color }) => ({
  "& .MuiOutlinedInput-root": {
    fontFamily: "'Quicksand', sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    color: color || colors.primary,
    border: "none",
    width: "100%",
    height: "55px",
    background: "transparent",
    borderRadius: 14,
    boxShadow:
      "-4px -4px 17.8px 0px rgba(173, 183, 194, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "14px",
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid rgba(73,42,24, 0.2)",
    },
    "& .MuiOutlinedInput-input": {
      color: color || colors.primary,
    },
    "& .MuiInputAdornment-root": {
      color: color || colors.primary,
    },
  },
}));

export const StyledValidationText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "10px",
  color: colors.primary,
  textAlign: "left",
  marginTop: 4,
  alignSelf: "start",
  [theme.breakpoints.up("sm")]: {
    fontSize: "12px",
  },
}));

export const StyledChipsContainer = styled(Box)({
  flexWrap: "wrap",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginTop: 8,
  width: "100%",
});

export const StyledChip = styled(Chip)({
  margin: 2,
  backgroundColor: colors.primary,
  color: "#fff",
  fontSize: "12px",
  fontWeight: "400",
  "& .MuiChip-deleteIcon": {
    color: "#fff",
    opacity: 1,
  },
  "&:hover": {
    backgroundColor: colors.primary,
    "& .MuiChip-deleteIcon": {
      color: "#fff",
      opacity: 1,
    },
  },
});
